import React from 'react';

const RightArrow = ({ height = '12px', width = '12px', ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 9 9" {...rest}>
    <path d="M9 4.5L0 0v9z" />
  </svg>
);

export default RightArrow;
